import {Component, computed, input} from '@angular/core';
import {CommonModule} from '@angular/common';

@Component({
    selector: 'app-phone',
    standalone: true,
    imports: [CommonModule],
    templateUrl: './app-phone.component.html',
    styleUrls: ['./app-phone.component.scss']
})
export class AppPhoneComponent {
    // Inputs
    areaCode = input<string | null>(null);
    phone = input<string | null>(null);
    showIcon = input<boolean>(true);
    showWhatsAppLink = input<boolean>(true);
    isFax = input<boolean>(false);

    // Computed para formatar telefone completo
    protected fullPhone = computed(() => {
        const area = this.areaCode();
        const number = this.phone();

        if (!number) return '—';

        // Remove caracteres não numéricos
        const cleanNumber = number.replace(/\D/g, '');

        // Aplica máscara baseada no tamanho
        let maskedNumber;
        if (cleanNumber.length === 9) {
            // Celular: 99999-9999
            maskedNumber = cleanNumber.replace(/^(\d{5})(\d{4})$/, '$1-$2');
        } else if (cleanNumber.length === 8) {
            // Fixo: 9999-9999
            maskedNumber = cleanNumber.replace(/^(\d{4})(\d{4})$/, '$1-$2');
        } else {
            maskedNumber = cleanNumber;
        }

        if (area) {
            return `(${area}) ${maskedNumber}`;
        }
        return maskedNumber;
    });

    // Computed para gerar link do WhatsApp
    protected whatsAppLink = computed(() => {
        const area = this.areaCode();
        const number = this.phone();

        if (!area || !number) {
            return null;
        }

        // Remove caracteres não numéricos
        const cleanArea = area.replace(/\D/g, '');
        const cleanNumber = number.replace(/\D/g, '');

        // Formato: +55 (DDD) número
        const fullNumber = `55${cleanArea}${cleanNumber}`;

        return `https://wa.me/${fullNumber}`;
    });

    // Computed para verificar se deve mostrar como link
    protected shouldShowLink = computed(() => {
        return this.showWhatsAppLink() && !this.isFax() && this.whatsAppLink() !== null;
    });
}

